import {
    SET_FCCOUNT,
} from './types';


const reducers = (state: any = {}, action: any) => {
    switch (action.type) {
        case SET_FCCOUNT:
            
            return {
                ...state, fcClick: action.values
            }  
         
        default:
            return state;
    }
};

export default reducers;




